import { PUBLIC_BETWATCH_API_ENDPOINT } from '$env/static/public';
import type { UserResponse } from '$types/races';

export async function getUser(
  f: typeof fetch,
  auth: { accessToken: string | undefined; guestId: string | undefined },
  { retriesLeft = 5, retryDelay = 1000 } = {}
) {
  const headers = {
    'Content-Type': 'application/json'
  } as Record<string, string>;
  if (auth.accessToken) {
    headers['Authorization'] = `Bearer ${auth.accessToken}`;
  } else if (auth.guestId) {
    headers['X-Guest-Id'] = auth.guestId;
  } else {
    throw new Error('No auth provided');
  }

  const user = (await f(PUBLIC_BETWATCH_API_ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      query: `
          query GetUser {
              user {
              id
              name
              email
              billingInformation {
                  subscriptions {
                  status
                  trialEnd
                  priceId
                  }
              }
              alertConfig {
                  telegramId
                  alertSound
                  email
                  discordWebhookUrl
              }
              apiKeys {
                  name
                  key
                  type
                  lastUsed
              }
              siteConfig {
                  hideAbandonedRaces
                  alternateColourMode
                  autoEventNav
                  relativeEventTime
                  betfairReductionFactor
                  prefill {
                    enabled
                    quickFill
                    defaults {
                      thoroughbred {
                        type
                        value
                      }
                      harness {
                        type value
                      }
                      greyhound {
                        type value
                      }
                    }
                  }
              }
              layoutConfigs {
                  boldTopPrice
                  layoutPreferences {
                  bookmaker
                  level
                  locked
                  side
                  type
                  name
                  size
                  period
                  }
                  name
                  scratchedRunnerVisibility
                  showRemainingBookmakers
                  remainingBookmakerSort
                  runnerSort
                  runnerPriceSortBookmaker
              }
              }
          }
          `
    })
  })
    .then((resp) => resp.json())
    .catch(async (err) => {
      if (retriesLeft) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        return getUser(f, auth, {
          retriesLeft: retriesLeft - 1,
          retryDelay: retryDelay * 2
        });
      }
      throw err;
    })) as UserResponse;

  // parse dates
  user?.data?.user?.apiKeys?.forEach((apiKey) => {
    apiKey.lastUsed = new Date(apiKey.lastUsed);
  });

  return user;
}
